import { gql } from "@apollo/client";

const GET_ALL_ORDEN_PEDIDOS = gql`
    query allOrdenPedidos($idEvaluacion: Int!) {
        allOrdenPedidos(idEvaluacion: $idEvaluacion) {
            idOrdenPedido
            codSAPVenta
            numeroRemito
            idEstado
            estadoDescripcion
            fechaEntrega
            tieneArchivoRemito
        }
    }
`;

export default GET_ALL_ORDEN_PEDIDOS;

export const adaptOrdenPedido = (ordenPedido) => {
  return {
    idOrdenPedido: ordenPedido?.idOrdenPedido,
    codSAPVenta: ordenPedido?.codSAPVenta,
    numeroRemito: ordenPedido?.numeroRemito,
    idEstado: ordenPedido?.idEstado,
    estadoDescripcion: ordenPedido?.estadoDescripcion,
    fechaEntrega: ordenPedido?.fechaEntrega,
    tieneArchivoRemito: ordenPedido?.tieneArchivoRemito
  };
};

export const adaptOrdenPedidosArray = (ordenPedidos) => {
  return structuredClone(ordenPedidos)?.
  map((ordenPedido) => adaptOrdenPedido(ordenPedido));
};